import { FC, PropsWithChildren, ReactNode } from 'react';

import { type Action, useHasPermission } from './useHasPermission';

type HasPermissionProps = PropsWithChildren<{
  action?: Action;
  /**
   * Alternative component to display if user does not have permission
   */
  fallback?: ReactNode;
}>;

export const HasPermission: FC<HasPermissionProps> = ({ children, action, fallback }) =>
  useHasPermission(action) ? children : (fallback ?? null);
